import styled from '../../../../styles/legacy/styled/styled'
import { GridLayout } from '../GridLayout'

// N'existe que pour surcharger le margin intégré au SelectInput T_T
export const GridLayoutWithoutChildMargin = styled(GridLayout)`
  & > div {
    margin: 0;
  }
`
